export type Theme = "dark" | "black" | "white" | "cream";

export interface ThemeColors {
  bg: string; bg2: string; bg3: string;
  border: string; text: string; textMuted: string; textDim: string;
  accent: string; accentDim: string; accentBorder: string;
  tag: string; tagText: string;
}

export const THEMES: Record<Theme, ThemeColors> = {
  white: {
    bg: "#ffffff", bg2: "#f8f8f8", bg3: "#f0f0f0",
    border: "#e8e8e8", text: "#0a0a0a", textMuted: "#767676", textDim: "#c8c8c8",
    accent: "#0a0a0a", accentDim: "rgba(10,10,10,0.05)", accentBorder: "rgba(10,10,10,0.15)",
    tag: "#f0f0f0", tagText: "#767676",
  },
  cream: {
    bg: "#f7f4ee", bg2: "#f0ece4", bg3: "#e8e3d8",
    border: "#ddd8cc", text: "#1c1812", textMuted: "#8c8070", textDim: "#c0b8a8",
    accent: "#1c1812", accentDim: "rgba(28,24,18,0.06)", accentBorder: "rgba(28,24,18,0.15)",
    tag: "#e8e3d8", tagText: "#8c8070",
  },
  dark: {
    bg: "#111111", bg2: "#191919", bg3: "#222222",
    border: "#2e2e2e", text: "#f0f0f0", textMuted: "#666666", textDim: "#3a3a3a",
    accent: "#f0f0f0", accentDim: "rgba(240,240,240,0.06)", accentBorder: "rgba(240,240,240,0.15)",
    tag: "#222222", tagText: "#666666",
  },
  black: {
    bg: "#000000", bg2: "#0a0a0a", bg3: "#141414",
    border: "#1e1e1e", text: "#ffffff", textMuted: "#555555", textDim: "#282828",
    accent: "#ffffff", accentDim: "rgba(255,255,255,0.05)", accentBorder: "rgba(255,255,255,0.12)",
    tag: "#141414", tagText: "#555555",
  },
};
